import { AddNewStory, Feed, FeedFilters } from './index'
import React, { FC } from 'react'

export const StoriesFeed: FC = () => {
  return <>
    <AddNewStory isFeedPage={true}>
      <FeedFilters />
    </AddNewStory>
    <Feed />
  </>
}
